import { LandingScreenshotPreview } from "./LandingScreenshotPreview";
import { LandingProductPreview } from "./LandingProductPreview";

type LandingBenefitPreviewProps = {
  variant: "runway" | "funding-calculator" | "investor-business-plan";
  className?: string;
};

export function LandingBenefitPreview({
  variant,
  className = "",
}: LandingBenefitPreviewProps) {
  if (variant === "runway") {
    return <LandingProductPreview className={className} />;
  }

  return <LandingScreenshotPreview screenshot={variant} className={className} />;
}
